class Sources {
	set filterGroup(value) {
		this._filterGroup = value;
		value.initialized = true;
	}

	constructor(type) {
		this.type = type;

		switch (this.type) {
			case 'resources':
				this.filters = [
					[0, 'Owned'],
					[1, 'Shared'],
					[2, 'Community'],
					[3, 'Supervised'],
					[4, 'Activity'],
				];
				break;
			case 'graphics':
				this.filters = [
					[0, 'Owned'],
					[1, 'Shared'],
					[2, 'Community'],
					[3, 'Supervised'],
				];
				break;
			default:
				this.filters = [];
		}
	}
}